import { render, staticRenderFns } from "./CreateAllowanceNotification.vue?vue&type=template&id=14d7fa29"
import script from "./CreateAllowanceNotification.vue?vue&type=script&lang=js"
export * from "./CreateAllowanceNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports